import { BaseRequest } from "../base-request";

export class TokenRequest extends BaseRequest {
  constructor(input: {
    Secret: string;
    PosName: string;
    PosVersion: string;
    PosId: string;
    PosVendorId: string;
  }) {
    super();
    this.Secret = input.Secret;
    this.PosName = input.PosName;
    this.PosVersion = input.PosVersion;
    this.PosId = input.PosId;
    this.PosVendorId = input.PosVendorId;
  }

  // Secret generated by sending a PairingRequest
  public Secret: string;

  // The name of the POS requesting the token
  public PosName: string;

  // The version of the POS requesting the token.</summary>
  public PosVersion: string;

  // A unique UUID v4 which identifies the POS instance. This value is generated by the POS as a part of
  // the POS deployment settings. e.g. Two registers at the same merchant should supply two different
  // PosId values.
  public PosId: string;

  // A unique UUID v4 which identifies the POS product. This value can be hard coded into the build of
  // the POS. e.g. All merchants using the same POS product should supply the same value.
  public PosVendorId: string;
}
